import { Button } from "antd";
import { useDispatch } from "react-redux";
import {
  updateDisplayRoomDrawer,
  updateShowMainBookingDetailsDrawer,
  updateShowTakePaymentDrawer,
} from "../../reducer/bookingReducer";
import { updateShowAttachToPartyDrawer } from "../../reducer/nightAuditReducer";
import { updateNightAuditModalDisplay } from "../../reducer/appHeaderReducer";

const Footer = ({
  handleSave,
  drawerWidth,
  activeTab,
  handlePendinReservationInBulk,
  data,
  setActiveTab,
  selectedInvoice,
  bulkUpdateLoading,
  printSummary,
}) => {
  const dispatch = useDispatch();

  const handleExtendBooking = () => {
    dispatch(
      updateShowMainBookingDetailsDrawer({
        visible: true,
        bookingId: selectedInvoice?.[0]?.id,
        bookingType:
          activeTab === 0
            ? "upcoming"
            : activeTab === 1
            ? "ongoing"
            : "completed",
      })
    );

    setTimeout(() => {
      dispatch(updateDisplayRoomDrawer());
    }, 200);
  };

  return (
    <div
      style={{ width: drawerWidth }}
      className="py-2  border-t-[1px] z-[50] bg-surface border-brand-border-muted shadow-mobile-footer fixed right-0 bottom-0 flex justify-end w-full px-4"
    >
      {activeTab === 0 && (
        <div className="w-[100%] flex justify-between items-center px-3 py-2">
          {Boolean(data?.length !== 0) ? (
            <div className="flex items-center gap-[18px]">
              {" "}
              <Button
                className="border-[1px] border-primary-light py-2 bg-primary-light text-primary"
                onClick={handleExtendBooking}
                loading={bulkUpdateLoading}
                disabled={selectedInvoice?.length !== 1}
              >
                Extend
              </Button>
              <Button
                className="text-fg-inverse py-2 bg-primary"
                onClick={() => handlePendinReservationInBulk("completed")}
                loading={bulkUpdateLoading}
                disabled={selectedInvoice?.length !== 1}
              >
                Check-Out
              </Button>
            </div>
          ) : (
            <div></div>
          )}

          <Button
            className="w-[130px] h-[35px]"
            disabled={data?.length > 0}
            onClick={() => setActiveTab((prev) => prev + 1)}
          >
            Next
          </Button>
        </div>
      )}

      {activeTab === 1 && (
        <div className="w-[100%] flex justify-between items-center px-3 py-2">
          {Boolean(data?.length !== 0) ? (
            <div className="flex items-center gap-[18px]">
              <Button
                className="border-[1px] border-danger py-2 bg-danger text-fg-inverse"
                onClick={() => handlePendinReservationInBulk("cancelled")}
                loading={bulkUpdateLoading}
              >
                Cancel
              </Button>{" "}
              <Button
                className="border-[1px] border-primary-light py-2 bg-primary-light text-primary"
                onClick={() => handlePendinReservationInBulk("noShow")}
                loading={bulkUpdateLoading}
              >
                No-Show
              </Button>
              <Button
                className="text-fg-inverse py-2 bg-primary"
                onClick={() => handlePendinReservationInBulk("checkedIn")}
                loading={bulkUpdateLoading}
              >
                Check-in
              </Button>
            </div>
          ) : (
            <div></div>
          )}

          <Button
            className="w-[130px] h-[35px]"
            disabled={data?.length > 0}
            onClick={() => setActiveTab((prev) => prev + 1)}
          >
            Next
          </Button>
        </div>
      )}

      {activeTab === 2 && (
        <div className="w-[100%] flex justify-between items-center px-3 py-2">
          {Boolean(data?.length !== 0) ? (
            <div className="flex items-center gap-[18px]">
              {" "}
              <Button
                className="border-[1px] border-primary-light py-2 bg-primary-light text-primary"
                onClick={() => dispatch(updateShowAttachToPartyDrawer(true))}
                disabled={selectedInvoice?.length !== 1}
              >
                Bill To Company
              </Button>
              <Button
                className="border-[1px] border-primary-light py-2 bg-primary-light text-primary"
                onClick={() => dispatch(updateShowTakePaymentDrawer(true))}
                disabled={selectedInvoice?.length !== 1}
              >
                Record Payment
              </Button>
            </div>
          ) : (
            <div></div>
          )}
          <Button
            className="w-[130px] h-[35px]"
            disabled={data?.length > 0}
            onClick={() => dispatch(updateNightAuditModalDisplay(true))}
          >
            Complete
          </Button>
        </div>
      )}

      {activeTab === 3 && (
        <div className="w-[100%]  px-3 py-2 flex justify-between items-center">
          <Button
            className="border-[1px] w-[105px] h-[40px] border-primary-light py-2 bg-primary-light text-primary"
            onClick={printSummary}
          >
            Print
          </Button>
        </div>
      )}
    </div>
  );
};

export default Footer;
